<template>
    <div>
        <div class>
            <Steps :active="2" align-center>
                <Step :title="$t('offering.offbase')" @click.native="on_click('offbaseAdd')" />
                <Step :title="$t('offering.offeringResources')" @click.native="on_click('offeringResourcesAdd')" />
                <Step :title="$t('offering.offconditionAdd')" />
                <Step :title="$t('offering.offnoticeAdd')" @click.native="on_click('offnoticeAdd')" />
                <Step :title="$t('offering.offpriceAdd')" @click.native="on_click('offpriceAdd')" />
                <Step :title="$t('offering.offinvestAdd')" @click.native="on_click('offinvestAdd')" />
                <Step :title="$t('offering.offabilityAdd')" @click.native="on_click('offabilityAdd')" />
            </Steps>
        </div>
        <br/>
        <div class='divMessage'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
        <br/>
         <el-card class="aui-card--fill"
                shadow="never">
          <div class='selecourseNameClass'>
            <el-form label-position="top"
               label-width="145px"
               :model="inServForm"
               :rules="dataRule"
               ref="inServForm">
            <el-row >
             <el-col :span="6">
                <!-- 开课前-->
                  <el-col :span="12">
                        <el-form-item :label="$t('couse.couseq')" prop="deadLineDays" style="width: 90px; float: left;">
                                    <!-- <el-tooltip content="截止报名(替换)" placement="bottom" effect="light"> -->
                                        <el-input v-model.number="inServForm.deadLineDays" maxlength="9"
                                                  style="width: 90px;">
                                        </el-input>
                                   <!-- </el-tooltip> -->
                                </el-form-item>
                            </el-col>
                            <el-col :span="9">
                                <el-form-item prop="deadLineFlag" style="width: 60px; padding-left: 2.5px;">
                                    <span slot="label">&nbsp;&nbsp;&nbsp;</span>
                                    <!-- <el-tooltip content="截止报名(替换)" placement="bottom" effect="light"> -->
                                        <el-select v-model="inServForm.deadLineFlag" style="width: 60px;"
                                                   filterable
                                                   >
                                            <el-option v-for="item in cousedaylist"
                                                       :key="item.value"
                                                       :label="item.label"
                                                       :value="item.value">
                                            </el-option>
                                        </el-select>
                                    <!-- </el-tooltip> -->
                                </el-form-item>
                            </el-col>
              </el-col>
              <el-col :span="6">
                <!-- 启用等待名单-->
                 <el-form-item :label="$t('couse.qiy')" prop="waitingListFlag">
                <el-select v-model="inServForm.waitingListFlag"
                           filterable
                           :placeholder="$t('course.select')">
                  <el-option v-for="(item,index) in newcourseProjectCF"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              </el-col>
                 <el-col :span="6">
                <!-- 允许店内替换-->
                <el-form-item :label="$t('couse.yxdealer')" prop="replaceUserFlag">
                  <el-tooltip content="截止替换时间与截止报名日期一致" placement="bottom" effect="light">
                  <el-select v-model="inServForm.replaceUserFlag" >
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                  </el-tooltip>
                  <!-- <span>截止替换时间与截止报名日期一致</span> -->
                </el-form-item>
              </el-col>
                <el-col :span="6">
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 3px">
                  <el-col :span="6" v-if="false">
                <!-- 允许重复报名-->
                <el-form-item :label="$t('couse.rxc')" prop="repeatRegistFlag">
                  <el-select v-model="inServForm.repeatRegistFlag" @change="changerepeatRegistFlag">
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 限制撤销报名-->
                <el-form-item :label="$t('couse.xz')" prop="revokeRegistFlag">
                  <el-select v-model="inServForm.revokeRegistFlag" >
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="inServForm.revokeRegistFlag == '10'">
                <!-- 限制撤销报名天数-->
                <el-form-item :label="$t('couse.xxc')"  prop="revokeRegistDays">
                  <el-input v-model.number="inServForm.revokeRegistDays" maxlength="9"
                  class="inputBox">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="1" v-if="false">
              <el-col :span="12">
                  <div class="location-layout"
                      v-if="inServForm.repeatRegistFlag == '20'">
                    <el-checkbox v-model="inServForm.repeatRegistRegisted" label="true"
                    true-label="true" false-label="false"
                                size="medium"><span style="font-size:12px">状态为已报名的不可重复报名</span></el-checkbox>
                  </div>
                  <div class="location-layout"
                      v-if="inServForm.repeatRegistFlag == '20'">
                       <!-- label="状态为已完成的不可重复报名" -->
                    <el-checkbox v-model="inServForm.repeatRegistComplete" label="true"
                    true-label="true" false-label="false"
                                ><span style="font-size:12px">状态为已完成的不可重复报名</span></el-checkbox>
                  </div>
                  <div class="location-layout"
                      v-if="inServForm.repeatRegistFlag == '20'">
                      <!-- label="状态为未完成的不可重复报名" -->
                    <el-checkbox v-model="inServForm.repeatRegistIncomplete"
                    true-label="true" false-label="false"
                                label="true"
                                size="medium"><span style="font-size:12px">状态为未通过的不可重复报名</span></el-checkbox>
                  </div>
              </el-col>
            </el-row>
                 <!-- 基本信息 -->
            <div class="opten-titlec">
            {{$t('couse.conditiontile')}}
              <!-- <el-tooltip placement="right" effect="light" >
          <div slot="content">{{ $t('couse.premisetMsg') }}</div>
            <em class="el-icon-question"></em>
        </el-tooltip> -->
           </div>
           <div style="margin-bottom:10px;">
            <span style="font-size: 8pt;">{{$t('couse.conditionnotice')}}</span></div>
             <div style="margin-bottom:10px;">
            <el-button  type="primary"
                      @click="courseAdd(inServForm.courseConditionList)">添加新选项</el-button>
             </div>
            <!-- "initcon" -->
            <el-table :data="infiledLists2"
                      :show-header="false"
                      style="width: 100%;text-align: left;"
                      :row-class-name="tableRowClassName"
                      :cell-style="cellStyle"
                      border
                      stripe
                      empty-text=" ">
              <el-table-column label="coursecode"
                              prop="options"
                              min-width="100px"
                              width="300px"
                              align="center">
                <template slot-scope="scope">
                  <span :id="'completeStatus' + scope.$index">{{$t('couse.allname')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="coursecode"
                              prop="state"
                              min-width="180px"
                              width="400px"
                              align="center">
                <template slot-scope="scope">
                  <span :id="'completeStatus2' + scope.$index">{{$t('couse.allstate')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="coursecode"
                              prop="optype"
                              min-width="80px"
                              align="center">
                <template slot-scope="scope">
                  <span :id="'completeStatus3' + scope.$index">{{$t('couse.alltype')}}</span>
                </template>
              </el-table-column>
               <!-- fixed="right" -->
              <el-table-column align="center"
                             prop="optypec"
                              width="80"
                              label="Operation"
                              >
                <template slot-scope="scope">
                  <span :id="'completeStatus4' + scope.$index">{{$t('couse.allcz')}}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-table
                      :data="inServForm.courseConditionList"
                      id="download"
                      :show-header="false"
                      :cell-style="cellStylec"
                      border
                      stripe
                      empty-text=" "
                      >
              <el-table-column label=""
                              min-width="140px"
                              align="left">
                 <template slot-scope="scope">
                  <condition @appenddata="appenddata"
                            @inputs="inputs"
                            @hiddens="hiddens"
                            @dayslist="dayslist"
                            :days="scope.row.days"
                            :inputvaluestrue22="scope.row.daysdisplay"
                            :inputvalues="scope.row.courseConditionList"
                            :inputvalues22="scope.row.optionIndex"
                            :inputvaluesfu="inServForm.courseConditionList"
                            :inputindex="scope.$index"
                            ref="condition"></condition>
                </template>
              </el-table-column>
            </el-table>
                <!-----------------20200609 开始-------------------------->
                <template>
                    <el-row :gutter="1">
                        <el-col :span="12">
                            <el-form-item label="   ">
                                <div class="dia">
                                    <el-radio  text-color="#303133" label="0" @change="blendreadFlagchange()" v-model="inServForm.offeringBlendRead"><span style="color: #303133;">{{ $t('couse.blendRead') }}</span></el-radio>
                                    <el-radio  text-color="#303133" label="1" @change="readFlagchange()" v-model="inServForm.offeringBlendRead"><span style="color: #303133;">{{ $t('couse.blendNread') }}</span>
                                    </el-radio>
                                </div>
                                <div style="margin-bottom:1px;">
                                    <span style="font-size: 8pt;">{{$t('couse.blendnotes')}}</span></div>
                                <div style="margin-bottom:1px;" v-if="courseBlendDisplay==false && inServForm.offeringBlendRead == '0'">
                                    <span style="font-size: 12pt;">{{$t('couse.blendnotesmsg')}}</span>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </template>
                <div class="location-layout" v-if="inServForm.offeringBlendRead == '0'">
                    <div style="margin-bottom:1px;" v-if="courseBlendDisplay==true">
                    <el-table :data="infiledLists2"
                              :show-header="false"
                              style="width: 100%;text-align: left;"
                              :row-class-name="tableRowClassName"
                              :cell-style="cellStyle"
                              border
                              stripe
                              empty-text=" ">
                        <el-table-column label="coursecode"
                                         prop="options"
                                         min-width="100px"
                                         width="300px"
                                         align="center">
                            <template slot-scope="scope">
                                <span :id="'completeStatus' + scope.$index">{{$t('couse.allname')}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="coursecode"
                                         prop="state"
                                         min-width="180px"
                                         width="400px"
                                         align="center">
                            <template slot-scope="scope">
                                <span :id="'completeStatus2' + scope.$index">{{$t('couse.allstate')}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="coursecode"
                                         prop="optype"
                                         min-width="80px"
                                         align="center">
                            <template slot-scope="scope">
                                <span :id="'completeStatus3' + scope.$index">{{$t('couse.alltype')}}</span>
                            </template>
                        </el-table-column>
                        <!-- fixed="right" -->
<!--                        <el-table-column align="center"-->
<!--                                         prop="optypec"-->
<!--                                         width="80"-->
<!--                                         label="Operation"-->
<!--                        >-->
<!--                            <template slot-scope="scope">-->
<!--                                <span :id="'completeStatus4' + scope.$index">{{$t('couse.allcz')}}</span>-->
<!--                            </template>-->
<!--                        </el-table-column>-->
                    </el-table>
                    <el-table
                            :data="inServForm.courseBlendConditionList"
                            id="download1"
                            :show-header="false"
                            :cell-style="cellStylec"
                            border
                            stripe
                            empty-text=" ">
                        <el-table-column label=""
                                         min-width="140px"
                                         align="left">
                            <template slot-scope="scope">
                                <blendcondition @blendappenddata="blendappenddata"
                                           @blendhiddens="blendhiddens"
                                           @blenddayslist="blenddayslist"
                                           :days="scope.row.days"
                                           :inputvaluestrue22="scope.row.daysdisplay"
                                           :inputvalues="scope.row.courseConditionList"
                                           :inputvalues22="scope.row.optionIndex"
                                           :inputvaluesfu="inServForm.courseBlendConditionList"
                                           :inputindex="scope.$index"
                                           ref="condition"></blendcondition>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>
                </div>
                <!--------------------结束----------------------->
            <!------------------------------------------->
            <!-- 注释掉 ---->
            <!-------------->
              <div class='selecourseNameClass'>
            <!-- <div style="margin-top:10px;"> <span size="2" color="#FF0000">{{$t('couse.conditiondesc')}}</span> </div> -->
             <div class="opten-title">
                {{$t('couse.conditionlimit')}}</div>
            <template>
              <el-row :gutter="1">
                <el-col :span="6">
                  <el-form-item label="   ">
                    <div class="dia">
                      <el-radio text-color="#303133" label="0" @change="setCourseLimitVal(), changeDefault()"  v-model="inServForm.limitRegistFlag"><span style="color: #303133;">{{ $t('couse.dealer') }}</span></el-radio>
                      <el-radio text-color="#303133" label="1" @change="limitDefineFlagchange()" v-model="inServForm.limitRegistFlag"><span style="color: #303133;">{{ $t('couse.dealerwx') }}</span>
                      </el-radio>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <el-row v-if="inServForm.limitRegistFlag==='0'">
                 <el-col :span="6">
                  <!-- 限定标准-->
                  <div class="location-layout" v-if="inServForm.limitRegistFlag != '1'">
                    <el-form-item :label="$t('couse.xdstandard')" prop="limitCourseFlag">
                      <el-select id="limitType" v-model="inServForm.limitCourseFlag" @change="setCourseLimitVal()"  :disabled = "limitCourseFlagtrue">
                        <el-option v-for="item in cousebz"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
            <!--开始时间-->
            <el-col :span="12" v-if="inServForm.limitCourseFlag == '10' && inServForm.limitRegistFlag != '1'">
                  <el-col :span="12">
                    <el-form-item :label="$t('couse.limitCourseStartdate')" prop="limitCourseStartdate">
                     <span slot="label">{{$t('couse.limitCourseStartdate')}}
                        <el-tooltip placement="bottom-start" effect="light" popper-class="limit-course-start-date">
                            <div slot="content">
                                学员在此时间段报名，则设置的限制报名人数规则生效，其他时间不生效。
                            </div>
                            <em class="el-icon-question" style="color: #1C69D3"></em>
                        </el-tooltip>
                     </span>
                    <el-date-picker width="60px" v-model="inServForm.limitCourseStartdate" :disabled="disableLimitWhenCourseType"
                    :placeholder="$t('couse.startdate')"
                    value-format="yyyy-MM-dd HH:mm:ss"
                              format="yyyy-MM-dd HH:mm:ss"
                              default-time="09:00:00"
                              type="datetime"
                    :picker-options="pickerOptionsStart" />
                  </el-form-item>
                  </el-col>
                    <el-col :span="12">
                     <el-form-item prop="limitCourseEnddate">
                       <span slot="label">&nbsp;&nbsp;&nbsp;</span>
                    <el-date-picker width="60px" v-model="inServForm.limitCourseEnddate" :disabled="disableLimitWhenCourseType"
                                :placeholder="$t('couse.enddate')"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss"
                                default-time="17:00:00"
                                type="datetime"
                                :picker-options="pickerOptionsEnd"/>
                     </el-form-item>
                  </el-col>
              </el-col>
            </el-row>
            <div v-if="inServForm.limitRegistFlag==='0'">
            <el-row :gutter="25" v-if="inServForm.limitRegistFlag==='0'">
              <el-col>
                <el-form-item label="    ">
                  <div v-if="inServForm.limitRegistFlag==='0'||inServForm.limitRegistFlag==='6'">
                    <!-- <el-row :gutter="25"> -->
                      <el-col :span="24">
                        <el-col :span="5">
                            <el-radio @change="limitDefineFlagchangefuz" :disabled="disableLimitWhenCourseType" v-model="inServForm.limitDefineFlag" label="3" ><span style="color: #303133;">每家经销商限制最多</span></el-radio>
                        </el-col>
                        <div v-if = "inServForm.limitDefineFlag === '3'">
                        <el-col :span="19">
                          <el-form-item label="" prop="limitDealerNumber" style="padding-left: 0.5px;padding-right: 12.5px;">
                                                <div id="container">
                                                    <div class="box1">
                                                        <el-input v-model.number="inServForm.limitDealerNumber"  maxlength="9" :disabled = "inServForm.limitDefineFlag === '1' || disableLimitWhenCourseType == true"
                                                                  style="width: 80px; float: left;">
                                                        </el-input>
                                                    </div>
                                                    <div class="box2"
                                                         style="width: 80px;padding-left: 10.5px; float: left;">
                                                        <span>人报名</span>
                                                    </div>
                                                </div>
                                </el-form-item>
                        </el-col>
                        </div>
                        <el-col :span="19" v-if = "inServForm.limitDefineFlag === '1'">
                          <el-form-item label=""  style="padding-left: 0.5px;padding-right: 12.5px;">
                                                <div id="container">
                                                    <div class="box1">
                                                        <el-input v-model.number="inServForm.limitDealerNumberz"  maxlength="9" :disabled = "inServForm.limitDefineFlag === '1' "
                                                                  style="width: 80px; float: left;">
                                                        </el-input>
                                                    </div>
                                                    <div class="box2"
                                                         style="width: 80px;padding-left: 10.5px; float: left;">
                                                        <span>人报名</span>
                                                    </div>
                                                </div>
                                </el-form-item>
                        </el-col>
                      </el-col>
                      <el-col :span="24">
                        <el-col :span="5">
                            <el-radio @change="limitDefineFlagchangefuuolod" :disabled="disableLimitWhenCourseType" v-model="inServForm.limitDefineFlag"  label="1" ><span style="color: #303133;">自定义上传</span></el-radio>
                        </el-col>
                        <div v-if="inServForm.limitDefineFlag === '1'">
                        <el-col :span="19">
                           <div id="container">
                                 <div class="box1" style="padding-left: 0.5px;padding-right: 12.5px;">
                                    <el-button size="small" type="primary" icon="el-icon-download" @click="exportCouseImporttemplate">下载模板</el-button>
                                    <el-button size="small"  @click="upload" :disabled = "inServForm.limitDefineFlag !== '1' || disableLimitWhenCourseType == true "
                                      type="primary">点击上传</el-button>
                                      </div>
                                     <div class="box1" style="padding-left: 5.5px;padding-right: 12.5px;">
<!--                              <span>除上传经销商外，其他经销商不受限制</span>-->
                              </div>
                           </div>
                        </el-col>
                        </div>
                      </el-col>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            </div>
            <el-row v-if="inServForm.limitRegistFlag==='0'&&inServForm.limitDefineFile!=''">
               <el-col :span="24">
              <el-link type="primary" :underline="false" @click="exportHandle">
                <!-- <el-form-item prop="limitDefineFile"> -->
                 <span>{{inServForm.limitDefineFile}}</span>
                 <!-- </el-form-item> -->
                  </el-link>
               </el-col>
            </el-row>
             </div>
            <div class="opten-title">
                {{$t('couse.conditionlimitOption')}}</div>
            <el-row >
              <el-col :span="6">
                <!-- 是否限制学习-->
                <el-form-item :label="$t('couse.ynstudyoffering')" prop="limitVisiableFlag">
                  <span slot="label">{{$t('couse.ynstudyoffering')}}
                    <el-tooltip placement="bottom-start" effect="light" >
                      <div slot="content">
                        组群限制生效条件：是否限制查看选择“是”，且选择了面向组群。只有组群内的用户可以查看和报名排期。选择多个组群时，组群间是“或”的关系。
                      </div>
                      <em class="el-icon-question" style="color: #1C69D3"></em>
                    </el-tooltip>
                  </span>
                  <el-select v-model="inServForm.limitVisiableFlag" >
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 站内信推送-->
                <el-form-item :label="$t('couse.zpush')" prop="sendNoticeFlag" >
                  <el-select v-model="inServForm.sendNoticeFlag" >
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
               <el-col :span="6">
                <!-- 允许兼职职位报名-->
                <!-- <el-form-item :label="$t('couse.allowjob')" prop="limitPartTimeJob">
                  <el-select v-model="inServForm.limitPartTimeJob" >
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item> -->
              </el-col>
            </el-row>
            <el-form-item required="true" v-show="inServForm.limitVisiableFlag === '10'" :label="$t('couse.csgroututitle')">
            </el-form-item>
            <!-- <div class="opten-title">
                {{$t('couse.csgroututitle')}} -->
              <!-- <el-tooltip placement="right" effect="light" >
              <div slot="content">{{ $t('couse.groupMsg') }}</div>
                <em class="el-icon-question"></em>
            </el-tooltip> -->
            <!-- </div> -->
            <el-row :gutter="1" v-show="inServForm.limitVisiableFlag === '10'">
              <el-col :span="24">
                <!-- <el-form-item label=""> -->
                  <!--面向群组 -->
                   <el-button
                        type="primary"
                        @click.native.prevent="openGroupDialog">{{ $t('couse.mgroup') }}</el-button>
                  <el-dialog
                          :visible.sync="dialogTableVisible"
                          title="选择组群"
                          width="1100px"
                          @close="closeFun">
                      <group ref="group" :openGroupId="openGroupId" @selectGroupData="getCloseData" :groupInfoList="inServForm.courseGroupList"></group>
                  </el-dialog>
              </el-col>
            </el-row>
            <el-row :gutter="1" style="margin: 0px !important;" v-show="inServForm.limitVisiableFlag === '10'">
              <el-form-item label="" v-if="inServForm.courseGroupList.length>0">
                <template>
                    <el-table :data="inServForm.courseGroupList"
                              border
                              style="width:60%"
                    >
                        <el-table-column prop="groupName"
                                         header-align="center"
                                         align="center"
                                         show-overflow-tooltip
                                         label="组群名称">
                        </el-table-column>
                        <el-table-column prop="groupRemark"
                                         header-align="center"
                                         align="center"
                                         show-overflow-tooltip
                                         label="组群描述">
                        </el-table-column>
                        <el-table-column prop="createUserName"
                                         header-align="center"
                                         align="center"
                                         show-overflow-tooltip
                                         label="创建人" >
                        </el-table-column>
                        <el-table-column align="center"
                                         label="操作"
                                         header-align="center"
                                         show-overflow-tooltip
                                         width="100">
                            <template slot-scope="scope">
                                <el-button @click.native.prevent="deleteRow(scope.$index, inServForm.courseGroupList)"
                                           size="small"> 删除 </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
              </el-form-item>
            </el-row>
             <div class="opten-title">
                {{$t('couse.equestitle')}}</div>
            <el-row :gutter="1">
              <el-col :span="24">
           </el-col>
            </el-row>
            <el-row :gutter="1">
                <el-form-item label="" v-if="inServForm.courseEqualDTOList.length>0">
                <template>
                   <el-table  style="width: 720px;" border
                   :cell-style="cellStylec"
                  :data="inServForm.courseEqualDTOList"
                  :span-method="arraySpanMethod">
                     <el-table-column prop="combName"
                                    :label="$t('couse.equecombination')"
                                    :width="100"
                                    align="center"
                                    show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="equalPackageNo"
                                    :label="$t('couse.equespackage')"
                                    :width="80"
                                    align="center"
                                    show-overflow-tooltip
                                    :formatter="equespackageformat">
                    </el-table-column>
                    <el-table-column prop="courseCode"
                                    :label="$t('couse.equescoursecode')"
                                    :width="150"
                                    align="center"
                                    show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="courseName"
                                     :label="$t('couse.equesname')"
                                     :width="150"
                                    align="center"
                                    show-overflow-tooltip>
                    </el-table-column>
                     <el-table-column prop="learningObjectFlag"
                                      :label="$t('couse.equestype')"
                                      :width="120"
                                    align="center"
                                    show-overflow-tooltip
                                    :formatter="kindformat">
                    </el-table-column>
                      <!--  -->
                     <el-table-column prop="courseStatus"
                                      :label="$t('couse.equesstate')"
                                      :width="119"
                                    align="center"
                                    show-overflow-tooltip
                                    :formatter="statusformat"
                                    >
                    </el-table-column>
                  </el-table>
                </template>
              </el-form-item>
            </el-row>
          </el-form>
          </div>
       </el-card>
         <courseimport @filenamelist="filenamelist"
                   v-if="importExcelVisible"
                  :courseId="inServForm.offeringId"
                  url="/learning/base/offeringinfo/import"
                  shuttering="/learning/base/offeringinfo/import_mould"
                  :name="$t('couse.couseImporttemplate')"
                  ref="courseimport"></courseimport>
        <div>
            <el-row style="float:right; margin-bottom: 60px;">
                <el-col :span="16"><div class="grid-content" /></el-col>
                <el-button v-if="$hasPermission('learning:offeringinfo:courseConditionSave') && $hasPermission('learning:offeringinfo:offeringNoticeSave')"
                           @click="btnSaveNextStep" :loading="loading" type="primary">{{ $t("course.saveAndNext") }}</el-button>
                <el-button v-if="$hasPermission('learning:offeringinfo:courseConditionSave')"
                           @click="btnSave"  :loading="loading" type="primary">{{ $t("course.save") }}</el-button>
                <ZElButton @click="btnCancel" >{{ $t("course.cancel") }}</ZElButton>
            </el-row>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 基本信息   offbaseAdd
// 报名条件   offconditionAdd
// 报名通知   offnoticeAdd
// 价格相关   offpriceAdd
// 调查问卷   offinvestAdd
// 能力项设置 offabilityAdd
import coursedcreat from '../../common/coursedcreat'
import debounce from 'lodash/debounce'
import condition from './offeringConditions'
import blendcondition from './blendofferingConditions'
import Courseimport from './offeringimports'
import ZElButton from '../../common/button/index'
import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
import group from '../../common/group/group'
export default {
// import引入的组件需要注入到对象中才能使用
  components: { Steps,
    Step,
    group,
    ZElButton,
    coursedcreat,
    condition,
    blendcondition,
    Courseimport },
  props: ['message', 'passOfferingId'],
  inject: ['toTop'],
  data () {
    let _this = this
    return {
        loading: false,
      openGroupId: 'offer',
      mixinViewModuleOptions: {
      },
      // message: '323232',
      limitCourseFlagtrue: false,
      dialogTableVisible: false,
      courseId: '',
      importExcelVisible1: false,
      importExcelVisible: false,
      groupInfoList: [],
      s1: '2',
      value: '',
      activ: 0,
      cousedaylist: [{
        value: 'd',
        label: '天'
      }, {
        value: 'h',
        label: '小时'
      }],
      // 是否 courseProjectCF
      newcourseProjectCF: _this.enums['courseProjectCF'],
      couseyesno: [{
        value: '10',
        label: '是'
      }, {
        value: '20',
        label: '否'
      }],
      // 限定标准
      cousebz: [{
        value: '10',
        label: '按课程'
      }, {
        value: '20',
        label: '按排期'
      }],
      // this.enums['status'],//是否为天或小时
      initcon: [],
      courseConditionList: [],
      infiledLists2: [{ options: 1 }],
      courseBlendDisplay:false,
      inServForm: {
        offeringId: '1',
        deadLineFlag: 'd',
        // repeatRegistRegisted: true,
        // courseId: '1',
        courseConditionList: [],
        courseLimidealerList: [],
        courseGroupList: [],
        courseEqueList: [],
        courseEqualDTOList: [],
        menuId: '',
        addressbaidu: 0,
        radio: '',
        chekex1: '',
        chekex2: '',
        active: 0,
        id: 45,
        sort: 0,
        courejoblist: [],
        // courseGroupList: []
        deadLineDays: 2,
        repeatRegistFlag: '20',
        waitingListFlag: '20',
        collectionDemandFlag: '20',
        limitVisiableFlag: '10',
        sendNoticeFlag: '10',
        limitPartTimeJob: '20',
        replaceUserFlag: '10',
        revokeRegistFlag: '20',
        limitRegistFlag: '1',
        limitCourseFlag: '20',
        limitDefineFlag: '3'
      },
      courseQuota: {
          limitCourseStartdate: '',
          limitCourseEnddate: '',
          limitDealerNumber: '',
          limitDefineFile: '',
          limitDefineFileid: '',
          limitDefineFlag: '',
          limitCourseFlag: '',

      },
      needMergeArr: ['combName', 'equalPackageNo'], // 有合并项的列
      rowMergeArrs: {}, // 包含需要一个或多个合并项信息的对象
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.inServForm.limitCourseEnddate
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime()
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.inServForm.limitCourseStartdate
          if (beginDateVal) {
            return (time.getTime() < new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000)
          }
        }
      },
      dataRulez: {
        waitingListFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        coursePrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {
      disableLimitWhenCourseType: function(){
          if (this.inServForm.limitCourseFlag === '10'){ //  10: 按课程  20：按排期
              return true
          }else{
              return false
          }

      },
    dataRule () {
      // this.$message('***********************')
      //  允许店内替换  replaceUserFlag
      //  培训需求收集  collectionDemandFlag
      //  限制撤销报名  revokeRegistFlag
      //  限制撤销报名天数  revokeRegistDays
      //  允许重复报名   repeatRegistFlag
      //  是否限制学习: limitVisiableFlag
      //  站内信推送  sendNoticeFlag
      //  等候名单  waitingListFlag
      let deadLineFlag = (rule, value, callback) => {
        if (this.inServForm.deadLineFlag === undefined || this.inServForm.deadLineFlag === null || this.inServForm.deadLineFlag === '') {
          callback(new Error(this.$t('validate.required')))
        }
        callback()
      }
      let maxRevokeRegistDays = (rule, value, callback) => {
        if (this.inServForm.revokeRegistDays !== null || this.inServForm.revokeRegistDays !== ' ') {
          if (isNaN(value)) {
            callback(new Error('必须为数字类型'))
          } else {
            if (!Number.isInteger(value)) {
              callback(new Error('必须为正整数'))
            }
          }
          if (value === 0) {
            callback(new Error('限制撤销报名天数必须大于0'))
          }
        }
        callback()
      }
      let maxdeadLineDays = (rule, value, callback) => {
        if (this.inServForm.deadLineDays !== null || this.inServForm.deadLineDays !== ' ') {
          if (isNaN(value)) {
            callback(new Error('必须为数字类型'))
          } else {
            if (!Number.isInteger(value)) {
              callback(new Error('必须为正整数'))
            }
          }
          if (value === 0) {
            callback(new Error('必须为正整数'))
          }
        }
        callback()
      }
      let maxlimitDealerNumber = (rule, value, callback) => {
        if (this.inServForm.limitDealerNumber !== null || this.inServForm.limitDealerNumber !== ' ') {
          if (isNaN(value)) {
            callback(new Error('必须为数字类型'))
          } else {
            if (!Number.isInteger(value)) {
              callback(new Error('必须为正整数'))
            }
          }
          if (value === 0) {
            callback(new Error('必须为正整数'))
          }
        }
        callback()
      }
      let limitCourseStartdate = (rule, value, callback) => {
        if (this.inServForm.limitCourseEnddate !== null || this.inServForm.limitCourseEnddate !== ' ') {
          if (value === this.inServForm.limitCourseEnddate && value === 0) {
            callback()
          }
          if (value >= this.inServForm.limitCourseEnddate) {
            callback(new Error('开始日期不能大于结束日期'))
          }
        }
        callback()
      }
      let limitCourseEnddate = (rule, value, callback) => {
        if (this.inServForm.limitCourseEnddate === undefined || this.inServForm.limitCourseEnddate === null || this.inServForm.limitCourseEnddate === '') {
          callback(new Error(this.$t('validate.required')))
        }
        if (this.inServForm.limitCourseStartdate !== null || this.inServForm.limitCourseStartdate !== ' ') {
          if (value === this.inServForm.limitCourseStartdate && value === 0) {
            callback()
          }
          if (value <= this.inServForm.limitCourseStartdate) {
            callback(new Error('结束日期不能小于开始日期'))
          }
        }
        callback()
      }
      return {
        courseConditionStatus: [{ type: 'string', required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        replaceUserFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        revokeRegistFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        revokeRegistDays: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: maxRevokeRegistDays, trigger: 'blur' }
        ],
        repeatRegistFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitVisiableFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sendNoticeFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitPartTimeJob: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        waitingListFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deadLineDays: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: maxdeadLineDays, trigger: 'blur' }
        ],
        limitDealerNumber: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: maxlimitDealerNumber, trigger: 'blur' }
        ],
        limitCourseStartdate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: limitCourseStartdate, trigger: 'blur' }
        ],
        limitCourseEnddate: [
          { validator: limitCourseEnddate, trigger: 'blur' }
        ],
        limitCourseFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deadLineFlag: [
          { validator: deadLineFlag, trigger: 'change' }
        ]
      }
    }
  },
  // 监控data中的数据变化
  watch: {
    "inServForm.limitVisiableFlag": {
      handler (newVal, oldVal) {
        if (newVal != "10") {
          this.inServForm.courseGroupList.splice(0, this.inServForm.courseGroupList.length)
        }
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // TODO 点击保存并下一步进入页面初始化数据
    this.$eventHub.$on('offbaseAdd', data => {
      this.again()
    })
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.$eventHub.$on('sendOfferCodition', data => {
      this.init(data)
    })

  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    if (this.$route.query.offeringId !== undefined && this.$route.query.offeringId !== '') {
      // #TODO 再次进入页面初始化数据
      console.log('再次进入 sigUpConditions')
      console.log(this.$route.query.offeringId)
      this.init(this.$route.query.offeringId)
    }
  },
  // 方法集合
  methods: {
    equespackageformat (row, column, cellValue){
     return this.getCaption(cellValue,1)  //输出
    },
		getCaption(obj,state) {
    var index=obj.lastIndexOf('\*');
    if(state==0){
        obj=obj.substring(0,index);
    }else {
        obj=obj.substring(index+1,obj.length);
    }
    return obj;
   },
    // 课程状态
    statusformat (row, column, cellValue) {
      if (cellValue === '10') {
        return '未发布'
      } else if (cellValue === '20') {
        return '已发布'
      } else if (cellValue === '30') {
        return '已下架'
      } else { return ' ' }
    },
    // 课程类型
    kindformat (row, column, cellValue) {
      if (cellValue === '10') {
        return '面授课'
      } else if (cellValue === '20') {
        return '微课'
      } else if (cellValue === '30') {
        return '慕课'
      } else if (cellValue === '40') {
        return '混合式学习'
      }
      else if (cellValue === '50') {
        return 'WBT'
      } else { return ' ' }
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      // 没办法循环判断具体是那一列 所以就只好写了多个if
      if (column.property === 'combName') return this.mergeAction('combName', rowIndex, column)
      if (column.property === 'equalPackageNo') return this.mergeAction('equalPackageNo', rowIndex, column)
    },
    mergeAction (val, rowIndex, colData) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      let _row = this.rowMergeArrs[val].rowArr[rowIndex]
      let _col = _row > 0 ? 1 : 0
      return [_row, _col]
    },
    rowMergeHandle (arr, data) {
      if (!Array.isArray(arr) && !arr.length) return false
      if (!Array.isArray(data) && !data.length) return false
      let needMerge = {}
      arr.forEach(i => {
        needMerge[i] = {
          rowArr: [],
          rowMergeNum: 0
        }
        data.forEach((item, index) => {
          if (index === 0) {
            needMerge[i].rowArr.push(1)
            needMerge[i].rowMergeNum = 0
          } else {
            if (item[i] === data[index - 1][i]) {
              needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1
              needMerge[i].rowArr.push(0)
            } else {
              needMerge[i].rowArr.push(1)
              needMerge[i].rowMergeNum = index
            }
          }
        })
      })
      return needMerge
    },
    // eslint-disable-next-line no-dupe-keys
    cellStylec ({ row, column, rowIndex, columnIndex }) {
      return {
        background: '#fff'
      }
    },
    limitDefineFlagchangefuuolod () {
      this.inServForm.limitDealerNumber = ''
      this.inServForm.limitDefineFlag = '1'
      this.inServForm.limitDefineFileid = ''
      this.setCourseLimitVal()
    },
    changerepeatRegistFlag () {
      // this.$message(this.inServForm.repeatRegistFlag)
      if (this.inServForm.repeatRegistRegisted !== undefined) {
        this.inServForm.repeatRegistRegisted = 'false'
      }
      if (this.inServForm.repeatRegistComplete !== undefined) {
        this.inServForm.repeatRegistComplete = 'false'
      }
      if (this.inServForm.repeatRegistIncomplete !== undefined) {
        this.inServForm.repeatRegistIncomplete = 'false'
      }
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.property) {
        return {
          background: '#ebecf0 !important',
          color: '#333333'
        }
      }
    },
    exportHandle () {
      // download 参数 url, params, 报表名
      var filename = this.inServForm.limitDefineFile.replace('.xls', '')
      this.$request.downloadLearning('/learning/base/offeringinfo/limitdownload', filename, { limitDefineFileid: this.inServForm.limitDefineFileid })
    },
    filenamelist (data) {
      this.inServForm.limitDefineFile = data.filename + ''
      this.inServForm.limitDefineFileid = data.filenameid + ''
    },
    // ************************************* */
    // 选无限制时
    limitDefineFlagchange () {
      this.inServForm.limitDefineFlag = '3'
      this.inServForm.limitDealerNumber = ''
    },
    limitDefineFlagchangefuz () {
      this.inServForm.limitDefineFile = ''
      this.inServForm.limitDefineFileid = ''
      this.setCourseLimitVal()
    },
    setCourseLimitVal (){
        if (this.inServForm.limitCourseFlag == '10') { // 10: 按课程
            this.inServForm.limitCourseStartdate = this.courseQuota.limitCourseStartdate
            this.inServForm.limitCourseEnddate = this.courseQuota.limitCourseEnddate
            this.inServForm.limitDealerNumber = this.courseQuota.limitDealerNumber
            this.inServForm.limitDefineFile = this.courseQuota.limitDefineFile
            this.inServForm.limitDefineFileid = this.courseQuota.limitDefineFileid
            this.inServForm.limitDefineFlag = this.courseQuota.limitDefineFlag
        }else if (this.inServForm.limitCourseFlag == '20'){ // 20: 按排期
            this.inServForm.limitDealerNumber = ''
            this.inServForm.limitDefineFile = ''

            if (this.courseQuota.limitCourseFlag == '20'){ // 20: 按排期
                this.limitCourseFlagtrue = true
            }
        }

    },
    changeDefault (){
       if (this.courseQuota.limitCourseFlag == '20'){
           this.inServForm.limitCourseFlag = '20'
           this.limitCourseFlagtrue = true
       }

    },
    // 人报名
    number () {
      var limitDealerNumber = this.inServForm.limitDealerNumber
      var sskey = limitDealerNumber.replace(new RegExp('.', 'g'), '')
      this.inServForm.limitDealerNumber = sskey
    },
    // 天数
    deadLineDays () {
      var deadLineDays = this.inServForm.deadLineDays
      var sskey = deadLineDays.replace(new RegExp('.', 'g'), '')
      this.inServForm.deadLineDays = sskey
    },
    // 格式化不能输入
    revokeRegistDays () {
      var revokeRegistDays = this.inServForm.revokeRegistDays
      var sskey = revokeRegistDays.replace(new RegExp('.', 'g'), '')
      this.inServForm.revokeRegistDays = sskey
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'warning-row'
      }
      return ''
    },
    blendreadFlagchange(){
        if (this.$route.query.offeringId !== undefined && this.$route.query.offeringId !== '') {
            this.$request.get('/learning/base/offeringinfo/offeringcourseBlend',
                {courseId: this.$route.query.offeringId, courseCode:this.inServForm.courseCode}
            ).then((res, total, code, data) => {
                this.inServForm.courseBlendConditionList = data.data
                if (this.inServForm.courseBlendConditionList.length > 0) {
                    this.courseBlendDisplay = true
                } else {
                    if (this.inServForm.offeringBlendRead == '0') {
                        this.courseBlendDisplay = false
                    } else {
                        this.courseBlendDisplay = true
                    }

                }
            }).catch(() => {
                // this.$message('444')
            })
        }
      },
    upload () {
      this.importExcelVisible = true
      this.$nextTick(() => {
        this.$refs.courseimport.init()
      })
      // this.getDataList()
    },
    sendMsg1 () {
      console.log('csconditionsend')
      console.log(this.courseid)
      this.$emit('onShowModer', 'cspricesend')
    },
    sendSave1 () {
      this.$emit('onShowModer', 'cspriceSave')
    },
    on_click1 (e) {
      this.$emit('onShowModer', e)
    },
    // 设置为了空白
    again () {
      this.inServForm = {
        deadLineFlag: 'd',
        // repeatRegistRegisted: true,
        // courseId: '1',
        courseConditionList: [],
        courseLimidealerList: [],
        courseGroupList: [],
        courseEqualDTOList: [],
        menuId: '',
        addressbaidu: 0,
        radio: '',
        chekex1: '',
        chekex2: '',
        active: 0,
        id: 45,
        sort: 0,
        courejoblist: [],
        // courseGroupList: []
        deadLineDays: 2,
        repeatRegistFlag: '20',
        waitingListFlag: '20',
        limitVisiableFlag: '10',
        sendNoticeFlag: '10',
        limitPartTimeJob: '20',
        replaceUserFlag: '10',
        revokeRegistFlag: '20',
        limitRegistFlag: '1',
        limitCourseFlag: '20',
        limitDefineFlag: '3'
      }
    },
    // 页面初始化
      init1 () {
      this.again()

      if (this.$route.query.courseId !== undefined) {
        this.inServForm.courseId = this.$route.query.courseId
        this.getDealerBeforeGetInfo()
      }
    },
    getDealerBeforeGetInfo () {
      // this.$request.post(`/learning/course/courseinfo/courseConditionUpdate`,
      this.$request.get('/learning/base/offeringinfo/offeringConditionList',
        { courseId: this.inServForm.courseId }
      ).then((res, total, code, data) => {
        this.$store.commit('getoffCourse', data.data)
        this.inServForm = data.data

        this.courseQuota.limitCourseStartdate = data.data.limitCourseStartdate
        this.courseQuota.limitCourseEnddate = data.data.limitCourseEnddate
        this.courseQuota.limitDealerNumber = data.data.limitDealerNumber

        if (this.inServForm.limitDefineFlag === null) {
          this.inServForm.limitRegistFlag = '1'
          this.inServForm.limitDefineFlag = '3'
        }
        if (this.inServForm.limitCourseFlag !== null && this.inServForm.limitCourseFlag === '20') {
          this.limitCourseFlagtrue = true
        } else {
          this.limitCourseFlagtrue = false
        }

        this.checkLimitFlagByCourse(this.inServForm.courseId)

          if(this.inServForm.courseBlendConditionList.length > 0){
              this.courseBlendDisplay=true
          }else{
              if(this.inServForm.offeringBlendRead=='0'){
                  this.courseBlendDisplay=false
              }else{
                  this.courseBlendDisplay=true
              }

          }
        this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, this.inServForm.courseEqualDTOList) // 处理数据
      }).catch((err) => {
        console.log(err)
      })
    },
    checkLimitFlagByCourse(courseId){
        this.$request.get('/learning/base/offeringinfo/getCouseLimitFlag',
            { courseId: courseId }
        ).then((res, total, code, data) => {
            let course = data.data
            if(course != null ){ // 课程限制标条件是按课程
                if(course.limitCourseFlag == '10'){
                    this.limitCourseFlagtrue = false
                }else if(course.limitCourseFlag == '20' && this.inServForm.limitCourseFlag == '20'){
                    this.limitCourseFlagtrue = true
                }

                var startVal = course.limitCourseStartdate
                if (startVal != null && startVal.length > 19) {
                    startVal = startVal.substr(0, 19)
                }

                var endVal = course.limitCourseEnddate
                if (endVal != null && endVal.length > 19) {
                    endVal = endVal.substr(0, 19)
                }


                if(startVal != null){
                    this.courseQuota.limitCourseStartdate = startVal
                }

                if(endVal != null){
                    this.courseQuota.limitCourseEnddate = endVal
                }

                if(course.limitDealerNumber != null){
                    this.courseQuota.limitDealerNumber = course.limitDealerNumber
                }

                this.courseQuota.limitDefineFile =  course.limitDefineFile
                this.courseQuota.limitDefineFileid = course.limitDefineFileid
                this.courseQuota.limitDefineFlag = course.limitDefineFlag
                this.courseQuota.limitCourseFlag = course.limitCourseFlag

            }

        }).catch((err) => {
          console.log(err)
        })

    },
    gotoView (id) {
      this.$router.push({
        name: 'learning-coursectg-cataglog'
      })
    },
    // 表单提交
    btnSaveNextStep: debounce(function () {
      // 有输入天数的要必填
      var dayss = true
      var dayssd0 = true
      var courseConditionList = true
      var courseConditionListzilist = true
      var courseUplodlist = true
        var blenddayss = true
        var blenddayssd0 = true
        var blendcourseConditionList = true
        var blendcourseConditionListzilist = true
      if (this.inServForm.limitVisiableFlag === '10' && this.inServForm.courseGroupList.length === 0) {
        this.$message({
            showClose: true,
            message: '请选择组群',
            type: 'error',
            duration: 2000
          })
          return false
      }
        this.inServForm.courseBlendConditionList.forEach(row => {
            if (row.courseConditionList.length === 0) {
                blendcourseConditionListzilist = false
            }
            if (row.daysdisplay !== '20') {
                row.days = null
            }
            if (row.daysdisplay === '20' && row.days === undefined) {
                blenddayss = false
            }
            if (row.daysdisplay === '20' && (row.days === undefined || row.days === '' || row.days === null)) {
                blenddayss = false
            }
            if (row.daysdisplay === '20' && row.days === '0') {
                // dayssd0 = false
            }
            if (row.days) {
                if (isNaN(row.days)) {
                    blenddayssd0 = false
                } else {
                    var nulms = Number(row.days)
                    if (!Number.isInteger(nulms)) {
                        blenddayssd0 = false
                    }
                    if(Number.isInteger(nulms)&&nulms<0){
                        blenddayssd0 = false
                    }
                }
            }
            row.courseConditionList.forEach(row2 => {
                if (row2.courseConditionStatus.length === 0) {
                    blendcourseConditionList = false
                }
                // 设置为空
                if (row.daysdisplay !== '20') {
                    row2.days = null
                }
            })
        })
      this.inServForm.courseConditionList.forEach(row => {
        if (row.courseConditionList.length === 0) {
          courseConditionListzilist = false
        }
        if (row.daysdisplay !== '20') {
          row.days = null
        }
        if (row.daysdisplay === '20' && row.days === undefined) {
          dayss = false
        }
        if (row.daysdisplay === '20' && (row.days === undefined || row.days === '' || row.days === null)) {
          dayss = false
        }
        if (row.daysdisplay === '20' && row.days === '0') {
         // dayssd0 = false
        }
        if (row.days) {
          if (isNaN(row.days)) {
            dayssd0 = false
          } else {
            var nulms = Number(row.days)
            if (!Number.isInteger(nulms)) {
              dayssd0 = false
            }
              if(Number.isInteger(nulms)&&nulms<0){
                  dayssd0 = false
              }
          }
        }
        row.courseConditionList.forEach(row2 => {
          if (row2.courseConditionStatus.length === 0) {
            courseConditionList = false
          }
          // 设置为空
          if (row.daysdisplay !== '20') {
            row2.days = null
          }
        })
      })
      if (this.inServForm.limitDefineFlag === '1') {
        // this.getDealeruplodlistInfo()
        // courseUplodlist = this.courseUplodlist
        if (this.inServForm.limitDefineFile === null || this.inServForm.limitDefineFile === '') {
          courseUplodlist = false
        }
      }

      if (this.inServForm.limitCourseStartdate === null || this.inServForm.limitCourseStartdate === '') {
        this.inServForm.limitCourseStartdate = null
      }
      if (this.inServForm.limitCourseStartdate != null && this.inServForm.limitCourseStartdate !== '') {
        this.inServForm.limitCourseStartdate = this.inServForm.limitCourseStartdate + ''
      }

      if (this.inServForm.limitCourseEnddate === null || this.inServForm.limitCourseEnddate === '') {
        this.inServForm.limitCourseEnddate = null
      }
      if (this.inServForm.limitCourseEnddate != null && this.inServForm.limitCourseEnddate !== '') {
        this.inServForm.limitCourseEnddate = this.inServForm.limitCourseEnddate + ''
      }
      this.inServForm.courseId = this.courseid
      let dataFormModify = JSON.parse(JSON.stringify(this.inServForm))
      this.$refs['inServForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if (!courseConditionListzilist) {
          this.$message({
            showClose: true,
            message: '选项下没有子项',
            type: 'error',
            duration: 5000
          })
          return false
        }
        if (!courseConditionList) {
              this.$message({
                  showClose: true,
                  message: '状态不允许为空',
                  type: 'error',
                  duration: 5000
              })
              return false
          }
          if (!dayss) {
              this.$message({
                  showClose: true,
                  message: '天数不允许为空',
                  type: 'error',
                  duration: 5000
              })
              return false
          }
          if (!dayssd0) {
              this.$message({
                  showClose: true,
                  message: '天数必须为正整数',
                  type: 'error',
                  duration: 5000
              })
              return false
          }
          if (!blendcourseConditionList) {
              this.$message({
                  showClose: true,
                  message: '状态不允许为空',
                  type: 'error',
                  duration: 5000
              })
              return false
          }
          if (!blenddayss) {
              this.$message({
                  showClose: true,
                  message: '天数不允许为空',
                  type: 'error',
                  duration: 5000
              })
              return false
          }
          if (!blenddayssd0) {
              this.$message({
                  showClose: true,
                  message: '天数必须为正整数',
                  type: 'error',
                  duration: 5000
              })
              return false
          }
        if (!courseUplodlist) {
          this.$message({
            showClose: true,
            message: '自定义上传没有上传文件',
            type: 'error',
            duration: 5000
          })
          return false
        }
         this.loading = true
        this.$request.post(`/learning/base/offeringinfo/courseConditionUpdate`,
          dataFormModify
        ).then((res, total, code, data) => {
          if (data.code === 13000000) {
            this.$message({
              message: this.$t(data.msg),
              type: 'error',
              duration: 2000
            })
          } else {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500

            })
            if (this.inServForm.limitCourseFlag !== undefined && this.inServForm.limitCourseFlag !== null && this.inServForm.limitCourseFlag === '20') {
              this.limitCourseFlagtrue = true
            } else {
              this.limitCourseFlagtrue = false
            }
             this.loading = false
            this.sendMsg()
          }
        }).catch(() => { this.loading = false })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    // 表单提交
    btnSave: debounce(function () {
      var dayss = true
      var dayssd0 = true
      var courseConditionList = true
      var courseConditionListzilist = true
      var courseUplodlist = true
        var blenddayss = true
        var blenddayssd0 = true
        var blendcourseConditionList = true
        var blendcourseConditionListzilist = true
      if (this.inServForm.limitVisiableFlag === '10' && this.inServForm.courseGroupList.length === 0) {
        this.$message({
            showClose: true,
            message: '请选择组群',
            type: 'error',
            duration: 2000
          })
          return false
      }
        this.inServForm.courseBlendConditionList.forEach(row => {
            if (row.courseConditionList.length === 0) {
                blendcourseConditionListzilist = false
            }
            if (row.daysdisplay !== '20') {
                row.days = null
            }
            if (row.daysdisplay === '20' && row.days === undefined) {
                blenddayss = false
            }
            if (row.daysdisplay === '20' && (row.days === undefined || row.days === '' || row.days === null)) {
                blenddayss = false
            }
            if (row.daysdisplay === '20' && row.days === '0') {
                // dayssd0 = false
            }
            if (row.days) {
                if (isNaN(row.days)) {
                    blenddayssd0 = false
                } else {
                    var nulms = Number(row.days)
                    if (!Number.isInteger(nulms)) {
                        blenddayssd0 = false
                    }
                    if(Number.isInteger(nulms)&&nulms<0){
                        blenddayssd0 = false
                    }
                }
            }
            row.courseConditionList.forEach(row2 => {
                if (row2.courseConditionStatus.length === 0) {
                    blendcourseConditionList = false
                }
                // 设置为空
                if (row.daysdisplay !== '20') {
                    row2.days = null
                }
            })
        })
      this.inServForm.courseConditionList.forEach(row => {
        if (row.courseConditionList.length === 0) {
          courseConditionListzilist = false
        }
        if (row.daysdisplay !== '20') {
          row.days = null
        }
        if (row.daysdisplay === '20' && row.days === undefined) {
          dayss = false
        }
        if (row.daysdisplay === '20' && (row.days === undefined || row.days === '' || row.days === null)) {
          dayss = false
        }
        if (row.daysdisplay === '20' && row.days === '0') {
         // dayssd0 = false
        }
        if (row.days) {
          if (isNaN(row.days)) {
            dayssd0 = false
          } else {
            var nulms = Number(row.days)
            if (!Number.isInteger(nulms)) {
              dayssd0 = false
            }
              if(Number.isInteger(nulms)&&nulms<0){
                  dayssd0 = false
              }
          }
        }
        row.courseConditionList.forEach(row2 => {
          if (row2.courseConditionStatus.length === 0) {
            courseConditionList = false
          }
          // 设置为空
          if (row.daysdisplay !== '20') {
            row2.days = null
          }
        })
      })
      if (this.inServForm.limitDefineFlag === '1') {
        // this.getDealeruplodlistInfo()
        // courseUplodlist = this.courseUplodlist
        if (this.inServForm.limitDefineFile === null || this.inServForm.limitDefineFile === '') {
          courseUplodlist = false
        }
      }
      this.inServForm.courseId = this.courseid
      if (this.inServForm.limitCourseStartdate === null || this.inServForm.limitCourseStartdate === '') {
        this.inServForm.limitCourseStartdate = null
      }

      if (this.inServForm.limitCourseEnddate === null || this.inServForm.limitCourseEnddate === '') {
        this.inServForm.limitCourseEnddate = null
      }
      let dataFormModify = JSON.parse(JSON.stringify(this.inServForm))
      this.$refs['inServForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if (!courseConditionListzilist) {
          this.$message({
            showClose: true,
            message: '选项下没有子项',
            type: 'error',
            duration: 5000
          })
          return false
        }
        if (!courseConditionList) {
          this.$message({
            showClose: true,
            message: '状态不允许为空',
            type: 'error',
            duration: 5000
          })
          return false
        }
        if (!dayss) {
          this.$message({
            showClose: true,
            message: '天数不允许为空',
            type: 'error',
            duration: 5000
          })
          return false
        }
        if (!dayssd0) {
          this.$message({
            showClose: true,
            message: '天数必须为正整数',
            type: 'error',
            duration: 5000
          })
          return false
        }
          if (!blendcourseConditionList) {
              this.$message({
                  showClose: true,
                  message: '状态不允许为空',
                  type: 'error',
                  duration: 5000
              })
              return false
          }
          if (!blenddayss) {
              this.$message({
                  showClose: true,
                  message: '天数不允许为空',
                  type: 'error',
                  duration: 5000
              })
              return false
          }
          if (!blenddayssd0) {
              this.$message({
                  showClose: true,
                  message: '天数必须为正整数',
                  type: 'error',
                  duration: 5000
              })
              return false
          }
        if (!courseUplodlist) {
          this.$message({
            showClose: true,
            message: '自定义上传没有上传文件',
            type: 'error',
            duration: 5000
          })
          return false
        }
        //  dataFormModify.motherShopId = this.select2
          this.loading = true
        this.$request.post(`/learning/base/offeringinfo/courseConditionUpdate`,
          dataFormModify
        ).then((res, total, code, data) => {
          if (data.code === 13000000) {
            this.$message({
              message: this.$t(data.msg),
              type: 'error',
              duration: 2000
            })
          } else if (code === 2) {
            this.$message({
              showClose: true,
              message: this.$t(data.msg),
              type: 'error',
              duration: 500
            })
          } else {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500
            })
              this.loading = false
            this.sendSave()
          }
        }).catch(() => { this.loading = false })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    // 查询是否上传
    getDealeruplodlistInfo () {
      this.inServForm.courseId = this.courseid
      this.$request.get('/learning/base/offeringinfo/uplodlist',
        { courseId: this.inServForm.courseId }
      ).then((res, total, code, data) => {
        this.inServForm.courseLimidealerList = data.data
        // 为大于0的说明上传成功
        if (data.data.length > 0) {
          this.courseUplodlist = true
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    backPage () {
      this.$router.go(-1)
    },
    courescreat: function (data) {
      // this.$message(data)
      this.inServForm.courseGroupList = data
    },
    courseAdd (tableData, event) {
      if (this.inServForm.addressbaidu === undefined) {
        this.inServForm.addressbaidu = 0
      }
      // 清空时 从0开始
      let courseConditionList = this.inServForm.courseConditionList
      var max = 0
      if (courseConditionList.length === 0) {
        this.inServForm.addressbaidu = 0
      } else {
        courseConditionList.forEach(row => {
          var number = parseInt(row.optionIndex, 10)
          if (max <= number) {
            max = number
          }
        })
      }
      var count = Number(max) + Number(1)
      tableData.push({ optionIndex: '' + count, daysdisplay: '10', statu: '', courseConditionList: [] })
      // tableData.push({tableData:{ye:'0', fildna: '选项'+count,status:''}})
    },
    reds: function (index) {
      this.changeRed = index
    },
    getCheckedNodes () {
      var ridsb = this.$refs.tree.getCheckedNodes()// 获取当前的选中的数据{对象}
      ridsb.forEach(ids => {
        this.inServForm.tableData.push({ jobname: ids.label, jobcode: ids.id })
      })
    },
    clickitem (e) {
      //e === this.inServForm.limitRegistFlag ? this.inServForm.limitRegistFlag = e : this.inServForm.limitRegistFlag = e
      this.inServForm.limitRegistFlag = e
      if (this.inServForm.limitRegistFlag === 0) {
        this.inServForm.limitDefineFlag = '3'
        this.inServForm.radiogeo = ''
      } else if (this.inServForm.limitRegistFlag === 3) {
        this.inServForm.radiogeo = 3
      } else {
        this.inServForm.radiogeo = ''
      }
    },
    // 设置 列表文本框是否隐藏
    hiddens: function (list) {
      this.inServForm.courseConditionList.forEach(row => {
        if (row.optionIndex === list[0].names) {
          // 隐藏值
          row.daysdisplay = list[0].hiddernames
        }
      })
    },
      // 设置 列表文本框是否隐藏
      blendhiddens: function (list) {
          this.inServForm.courseBlendConditionList.forEach(row => {
              if (row.optionIndex === list[0].names) {
                  // 隐藏值
                  row.daysdisplay = list[0].hiddernames
              }
          })
      },
    // dayslist 获取天数
    dayslist: function (list) {
      this.inServForm.courseConditionList.forEach(row => {
        if (row.optionIndex === list[0].names) {
          // 隐藏值
          row.days = list[0].days
        }
      })
    },
      // dayslist 获取天数
      blenddayslist: function (list) {
          this.inServForm.courseBlendConditionList.forEach(row => {
              if (row.optionIndex === list[0].names) {
                  // 隐藏值
                  row.days = list[0].days
              }
          })
      },
    // 默认30 已完成
    appenddata: function (list) {
      this.inServForm.courseConditionList.forEach(row => {
        if (row.optionIndex === list[0].names) {
          list[0].data.forEach(rows => {
            // this.unique({ conditionCourseId: rows.id, course: rows.course, courseKind: rows.courseKind, courseConditionStatus: ['30'] })
            row.courseConditionList.push({ conditionCourseId: rows.id, course: rows.course, courseKind: rows.courseKind, courseConditionStatus: ['30'] })
          })
        }
      })
      this.inServForm.courseConditionList.forEach(row => {
        row.courseConditionList = this.quchong(row.courseConditionList)
      })
      // this.inServForm.courseConditionList = this.unique(this.inServForm.courseConditionList)
    },
      // 默认30 已完成
      blendappenddata: function (list) {
          this.inServForm.courseBlendConditionList.forEach(row => {
              if (row.optionIndex === list[0].names) {
                  list[0].data.forEach(rows => {
                      // this.unique({ conditionCourseId: rows.id, course: rows.course, courseKind: rows.courseKind, courseConditionStatus: ['30'] })
                      row.courseConditionList.push({ conditionCourseId: rows.id, course: rows.course, courseKind: rows.courseKind, courseConditionStatus: ['30'] })
                  })
              }
          })
          this.inServForm.courseBlendConditionList.forEach(row => {
              row.courseConditionList = this.quchong(row.courseConditionList)
          })
          // this.inServForm.courseConditionList = this.unique(this.inServForm.courseConditionList)
      },
    quchong (arr) {
      var result = []
      var obj = {}
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i].course]) {
          result.push(arr[i])
          obj[arr[i].course] = true
        }
      }
      return result
    },
    // 去重
    unique (arr) {
      if (!Array.isArray(arr)) {
        console.log('Type Error!')
        return false
      }
      var array = []
      for (var i = 0; i < arr.length; i++) {
        if (array.indexOf(arr[i]) !== -1) {
          array.push(arr[i])
        }
      }
      return array
    },
    // 集合去重
    uniqArrObject (arr) {
      let result = {}
      let finalResult = []
      for (let i = 0; i < arr.length; i++) {
        result[arr[i].course] = arr[i]
      }
      for (let key in result) {
        finalResult.push(result[key])
      }
      return finalResult
    },
    closeFun () {
      this.dialogTableVisible = false
    },
    openGroupDialog () {
      this.dialogTableVisible = true
      this.$nextTick(() => {
        this.$refs.group.initMethods()
      })
    },
    getCloseData (val) {
      if (val.id === 'offer') {
        this.dialogTableVisible = false
        this.inServForm.courseGroupList = val.data
      }
    },
    inputs: function (data) {
      // var indexx = 0
      var str = ''
      data.forEach(row => {
        str = row.name
        // indexx = row.indexs
        // indexx = ++index
      })
      var strs // =new Array()
      strs = str.split(',')
      for (var i = 0; i < strs.length; i++) {
        // document.write(strs[i]+"<br/>"); //分割后的字符输出
      }
    },

    deleteRow (index, rows) { // 删除改行
      this.$confirm(this.$t('prompt.info', { 'handle': '删除' }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(() => {
        rows.splice(index, 1)
      }).catch((err) => {
        console.log(err)
      })
    },
    objectArraySort (keyName) {
      return function (objectN, objectM) {
        var valueN = objectN[keyName]
        var valueM = objectM[keyName]
        if (valueN < valueM) return 1
        else if (valueN > valueM) return -1
        else return 0
      }
    },
    // 定义在每个小节的内部进行转化的方法，其他部分则与小节内部转化方法相同
    // 获取表格选中时的数据
    selectRow (val) {
      this.selectlistRow = val
    },

    // 增加行
    addRow () {
      var list = {
        rowNum: '',
        address: this.address,
        name: this.name,
        weather: this.weather,
        phone: this.phone,
        date: this.date,
        mdate: this.mdate,
        loveer: this.loveer
      }
      this.tableData.unshift(list)
    },
    // 删除方法
    // 删除选中行
    delData () {
      this.$confirm('111', '333', {
        confirmButtonText: '444',
        cancelButtonText: '111'
      }).then(() => {
        for (let i = 0; i < this.selectlistRow.length; i++) {
          let val = this.selectlistRow
          // 获取选中行的索引的方法
          // 遍历表格中tableData数据和选中的val数据，比较它们的rowNum,相等则输出选中行的索引
          // rowNum的作用主要是为了让每一行有一个唯一的数据，方便比较，可以根据个人的开发需求从后台传入特定的数据
          val.forEach((val, index) => {
            this.tableData.forEach((v, i) => {
              if (val.rowNum === v.rowNum) {
                // i 为选中的索引
                this.tableData.splice(i, 1)
              }
            })
          })
        }
        // 删除完数据之后清除勾选框
        this.$refs.tableData.clearSelection()
      }).catch((err) => {
        console.log(err)
      })
    },
    // ************************************* */
    // 设置初始化为空
    // 初始化数据
    init (offeringId) {
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
      // if (this.$route.query.courseId !== undefined) {
        this.inServForm.courseId = offeringId
        this.getDealerBeforeGetInfo()
        // this.getOffering(offeringId)
      // }
    },
      getOffering(offeringId) {
          this.dataForm.offeringId = offeringId
          if (this.dataForm.offeringId === null || this.dataForm.offeringId === '') {
              return
          }
          this.$request.get('/learning/base/offeringinfo/get/' + this.dataForm.offeringId
          ).then((res, total, code, data) => {
              this.dataForm = data.data
              if (this.dataForm.noticeEmailFalg === 'true') {
                  this.dataForm.noticeEmailFalg = true
              } else {
                  this.dataForm.noticeEmailFalg = false
              }
              if (this.dataForm.noticeLetterFlag === 'true') {
                  this.dataForm.noticeLetterFlag = true
              } else {
                  this.dataForm.noticeLetterFlag = false
              }
              if (this.dataForm.noteSmsFlag === 'true') {
                  this.dataForm.noteSmsFlag = true
              } else {
                  this.dataForm.noteSmsFlag = false
              }
              // if (this.dataForm.emailContent !== 'defaultTemp') {
              //     // console.info('初始文本' + this.dataForm.emailContent)
              //     // console.info('初始文本' + this.dataForm.emailContent.length)
              //     // console.info('初始文本' + this.emailContentTemp2.length)
              //     // this.emailContentTemp = this.dataForm.emailContent.slice(this.emailContentTemp2.length)
              // }
              // this.handleEmailCheck(this.dataForm.noticeEmailFalg)
              // this.handleLetterCheck(this.dataForm.noticeLetterFlag)
              // this.handleSmsCheck(this.dataForm.noteSmsFlag)
          }).catch((err) => {
            console.log(err)
          })
      },
    // 保存方法
    btnSave1 () {
      // TODO 成功调用  this.sendSave()
    },
    // 保存并下一步
    btnSaveNextStep1 () {
      // TODO  成功调用 this.sendMsg()
      this.sendMsg()
    },
    // 向父页面传递消息 跳转下一页面
    sendMsg () {
      this.toTop()
      this.$emit('onShowModer', 'offnoticesend')
    },
    // 向父页面传递消息 保存页面
    sendSave () {
      this.$emit('onShowModer', 'offnoticeSave')
      this.tabRemove()
      this.$router.push({
        name: 'learning-offering-offeringlist'
      })
    },
    // 点击导航跳转页面
    on_click (e) {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('onShowModer', e)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 取消按钮
    btnCancel () {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabRemove()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    // 导出
    exportCouseImporttemplate () {
      // download 参数 url, params, 报表名 /learning/base/offeringinfo/import_mould
      this.$request.download('/learning/base/offeringinfo/import_mould', '报名人数导入模板')
    }
  }
}
</script>
<style>
.el-form--label-top .el-form-item__label {
    /* float: none; */
    display: inline-block;
    text-align: left;
    padding: 0 0 10px;
}
.selecourseNameClass .el-form--label-top .el-form-item__label {
    /* float: none; */
    display: inline-block;
    text-align: left;
    padding: 0 0 10px;
}
.limit-course-start-date {
    max-width: 28rem !important;
}
</style>
<style lang='scss' scoped>
 .el-form--label-top .el-form-item__label {
    padding: 0px !important;
    width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
    // @import url(); 引入公共css类
.opten-titlec {
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
}
.grid-content {
        border-radius: 4px;
        min-height: 20px;
    }
.el-form-item__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
}
.el-form-item__error {
    /* width: 100%; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.el-table .warning-row {
     /* background: gray; */
     background: #ebecf0;
}
.el-form-item.is-required .el-form-item__label:before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .c-11 {
  border-radius: 50%;
  border: 15px solid;
  border-color: inherit;
}
.box {
  height: 40px;
  background: cyan;
}
.nav {
  line-height: 40px;
  display: inline-block;
  margin-left: 100px;
  cursor: pointer;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
#container {
  overflow: hidden;
} /* 清除浮动 */

/* #container div{height:100px;} */
#container div {
  /* width: 100px; */
  display: inline-block;
}

.box1 {
  float: left;
}
.box2 {
  float: left;
}
</style>
